function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepCheckboxListItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CheckboxList = require("../CheckboxList");
var _View = require("../View");
var _StepCard = require("../StepCard");
var _CardActions = require("../CardActions");
var StepButtons = _interopRequireWildcard(require("../StepButtons"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var StepCheckboxListItem = exports.StepCheckboxListItem = (0, _react.memo)(function (_ref) {
  var _action$themes;
  var items = _ref.items,
    _ref$selectedItems = _ref.selectedItems,
    selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems,
    onPress = _ref.onPress,
    style = _ref.style,
    categoryPillOnPress = _ref.categoryPillOnPress,
    action = _ref.action;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _hasItems = items && items.length > 0;
  return (0, _jsxRuntime.jsx)(_View.View, {
    style: [styles.container, style],
    testID: "StepCheckboxListItem",
    children: (0, _jsxRuntime.jsxs)(_StepCard.StepCard, {
      title: action.name,
      impact: action.impact,
      themes: (_action$themes = action.themes) == null ? void 0 : _action$themes.map(function (themeItem) {
        return themeItem.theme;
      }),
      categoryPillOnPress: categoryPillOnPress,
      style: styles.card,
      trackingContent: action.id,
      children: [_hasItems && (0, _jsxRuntime.jsx)(_CheckboxList.CheckboxList, {
        items: items,
        selectedItems: selectedItems,
        onPress: onPress
      }), (0, _jsxRuntime.jsxs)(_CardActions.CardActions, {
        style: styles.actions,
        children: [(0, _jsxRuntime.jsx)(StepButtons.Succeed, {
          action: action
        }), (0, _jsxRuntime.jsx)(StepButtons.LearnMore, {
          action: action
        })]
      })]
    })
  });
});